import React from "react";
import { UnstiledField, UnstiledReadonlyInput } from "../../common/Inputs";
import { connect } from "react-redux";
import { getFormValues, Field } from 'redux-form';

export const getOrderItemTotal = (services, item) => {
    if (!item.Service)
        return 0;

    if (item.Service.Id)
        return item.Amount * item.Service.Price;

    const service = services.find(s => s.Id === item.ServiceId);

    return service ? service.Price * item.Amount : 0;
}

let Total = class extends React.Component {

    render() {
        const { items, delivery, services, discount, hideDelivery } = this.props;
        if (!items || items.length === 0)
            return null;

        const sum = items.reduce((sum, item) => sum + getOrderItemTotal(services, item), 0);

        if (!delivery)
            return null;

        const deliveryPrice = sum > delivery.FreeDeliveryAmount ? 0 : delivery.DeliveryPrice;
        const discountPrice = discount ? discount : 0;

        return (<div>
            <div className='row' style={{ paddingRight: "15px", paddingLeft: "15px" }} >
                <div className='col-md-4'>
                    <Field component={UnstiledField} name='Discount' type='number' label='Скидка' />
                </div>
            </div>
            <div className='row' style={{ paddingRight: "15px", paddingLeft: "15px" }} >
                <div className='col-md-4'>
                    <UnstiledReadonlyInput value={`Сумма ${sum}`} />
                </div>
                {!hideDelivery && <div className='col-md-4'>
                    <UnstiledReadonlyInput value={`Доставка ${deliveryPrice}`} />
                </div>}
                <div className='col-md-4'>
                    <div style={{ textAlign: 'right' }}>
                        <UnstiledReadonlyInput value={`Итог ${(sum + (hideDelivery ? 0 : deliveryPrice) + Number(discountPrice))}`} />
                    </div>
                </div>
            </div>
        </div>);
    }
}

Total = connect((state, { formName }) => {
    const formValues = getFormValues(formName)(state);
    const discount = formValues ? formValues.Discount : 0;
    return { items: formValues ? formValues.Items : [], discount };
})(Total);

export default Total;


// WEBPACK FOOTER //
// ./src/components/orders/items/OrderTotal.jsx